export default class AppletSubgroupTypeEnum {
  public static FRONT_PASSENGER_DIAGONAL = 'FRONT_PASSENGER_DIAGONAL';

  public static FRONT = 'FRONT';

  public static FRONT_DRIVER_DIAGONAL = 'FRONT_DRIVER_DIAGONAL';

  public static REAR_DRIVER_DIAGONAL = 'REAR_DRIVER_DIAGONAL';

  public static REAR = 'REAR';

  public static REAR_PASSENGER_DIAGONAL = 'REAR_PASSENGER_DIAGONAL';

  public static ODOMETER = 'ODOMETER';

  public static MOTOR = 'MOTOR';

  public static STEPPE = 'STEPPE';

  public static CHASSIS = 'CHASSIS';

  public static DOCUMENT = 'DOCUMENT';

  public static FRONT_LEFT_DIAGONAL = 'FRONT_LEFT_DIAGONAL';

  public static FRONT_RIGHT_DIAGONAL = 'FRONT_RIGHT_DIAGONAL';

  public static REAR_LEFT_DIAGONAL = 'REAR_LEFT_DIAGONAL';

  public static REAR_RIGHT_DIAGONAL = 'REAR_RIGHT_DIAGONAL';

  public static TIRE = 'TIRE';

  public static DEFAULT = 'DEFAULT';

  public static VEHICLE_PARTS = 'VEHICLE_PARTS';
}
